import React from 'react';
import ReactDOM from 'react-dom/client';
import { isConsolePath, publicPageForPath } from './lib/publicHome';

const root = ReactDOM.createRoot(document.getElementById('root')!);

async function renderPage() {
  if (import.meta.env.VITE_CONSOLE_ONLY === 'true' && !isConsolePath(window.location.pathname)) {
    window.location.replace('/consoln/');
    return;
  }

  const page = publicPageForPath(window.location.pathname);
  if (page === 'console') {
    document.body.classList.remove('public-home-body');

    const [{ default: App }] = await Promise.all([
      import('./App'),
      import('./index.css'),
      import('./i18n/index'),
    ]);

    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
    return;
  }

  document.body.classList.add('public-home-body');

  const [{ default: PublicSite }] = await Promise.all([
    import('./pages/PublicSite'),
    import('./pages/PublicHome.css'),
  ]);

  root.render(
    <React.StrictMode>
      <PublicSite page={page} />
    </React.StrictMode>
  );
}

void renderPage();
